import React from 'react'
import classnames from 'classnames'
import Sidebar from '../Sidebar/Sidebar'
import { useLayoutState } from '../../../context/LayoutContext'
import useStyles from './styles'
import { AuthenticatedUserConsumer } from '../../../AuthenticatedUserContext'

function Layout ({ content }) {
  const classes = useStyles()
  const layoutState = useLayoutState()

  return (
    <div className={classes.root}>
      <>
        <AuthenticatedUserConsumer>
          {({ adminSectionType }) => (
            <Sidebar adminSectionType={adminSectionType}/>
          )}
        </AuthenticatedUserConsumer>
        <div className={classnames(classes.content, {
          [classes.contentShift]: layoutState.isSidebarOpened
        })}>
          <div className={classes.fakeToolbar}/>
          {content}
        </div>
      </>
    </div>
  )
}

export default Layout
